import { Theme, Typography } from '@mui/material'
import { CSSProperties, ReactNode } from 'react'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { CommonSchema } from './schemas/commonSchema'

const YB_GAM_AD_UNIT_PATH: string = '/52555387'

export const YbGamAdUnitPathSoftValidator = (): ReactNode => {
  const { t } = useTranslation('features/adUnit')
  const { path, ybAdUnitEnabled } = useWatch<CommonSchema>()

  const Text: JSX.Element = (
    <Typography
      color={(theme: Theme): CSSProperties['color'] => theme.palette.warning.main}
      component='span'
      variant='caption'
    >
      {t('form.general.basicAttributes.path.ybAdUnitDetected')}
    </Typography>
  )

  if (path?.startsWith(YB_GAM_AD_UNIT_PATH) && ybAdUnitEnabled === false) {
    return Text
  } else {
    return undefined
  }
}
